/** @jsxImportSource @emotion/react */
import { Dashboard } from '../components/Home/Dashboard'
import { HomeLayout } from './home/HomeLayout'

export const Home = () => {
  return (
    <HomeLayout>
      <Dashboard />
    </HomeLayout>
  )
}
